import MultiButtonSwitch from "../../../components/common/editors/MultiButtonSwitch";

export default function FragmentTypeEditor({ value, onChange, showAll = true }) {
    return <MultiButtonSwitch
        value={value}
        onChange={onChange}
        options={[
            ... (showAll ? [{ label: 'All', value: undefined }] : []),
            { label: 'Hard specs', value: 'textHardSpec' },
            { label: 'Image', value: 'image' },
        ]}
    />;
}
